import React from "react";
import { Image, Mic, Type, Camera, Repeat, Globe2 } from "lucide-react";
import { useLang } from "../lib/LangContext";

const ICONS = { image: Image, mic: Mic, type: Type, camera: Camera, repeat: Repeat, globe: Globe2 };

export const Chaos = () => {
  const { t } = useLang();
  return (
    <section className="px-6 md:px-12 lg:px-20 max-w-[1400px] mx-auto pt-20 pb-10 md:pt-28 md:pb-12">
      <div className="max-w-3xl">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-lokam-tangerine">
          Built for real Indian families
        </p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-lokam-forest">
          {t.chaos.title}
        </h2>
        <p className="mt-4 text-base md:text-lg text-lokam-ink-soft max-w-xl">
          {t.chaos.subtitle}
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {t.chaos.items.map((item, i) => {
          const Icon = ICONS[item.icon] || Image;
          return (
            <div
              key={i}
              data-testid={`chaos-item-${i}`}
              className="group relative rounded-2xl border border-lokam-border bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_48px_-20px_rgba(10,59,36,0.18)] hover:border-lokam-forest/30"
            >
              <div className="flex items-start gap-4">
                <div className="h-11 w-11 rounded-xl bg-lokam-sand flex items-center justify-center text-lokam-forest group-hover:bg-lokam-tangerine group-hover:text-white transition-colors">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="flex-1">
                  <div className="font-display font-semibold text-lokam-ink text-lg leading-tight">
                    {item.title}
                  </div>
                  <div className="mt-1.5 text-sm text-lokam-ink-soft">
                    {item.note}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Chaos;
